// This is for Review Embeds, not location embeds (location embed generator script is in the custom twig template)
import {createURL} from '@js/utils.js';
import {unserialize} from 'fmjs/url.js';
import {$} from 'fmjs/dom.js';

const getEmbedVars = (suggestion) => {
  const origin = location.origin;
  const isProduction = /paddling\.com$/.test(location.hostname);
  const {theme} = unserialize();
  const dataIframe = isProduction ? '' : `
    data-iframe="${origin}"`;
  const url = createURL(suggestion.uri);

  return {
    url,
    theme,
    iframe: !isProduction && origin,
    dataIframe,
    src: `${origin}/assets/js/paddling-reviews.js`,
    productid: suggestion.id,
  };
};

const getEmbedTemplate = (suggestion, theme = 'red', type) => {
  const {src, dataIframe, url} = getEmbedVars(suggestion);

  const innerEl = type === 'textarea' ? `<script
  src="${src}"
  data-productid="${suggestion.id}" data-theme="${theme}" ${dataIframe}
></script>` : '<div id="demo-container"></div>';

  return `<div>
  <h2><a href="${url}" target="_blank" rel="noopener">${suggestion.title} Reviews</a></h2>
  ${innerEl}
  Powered by <a href="https://paddling.com/" target="_blank" rel="noopener">paddling.com</a>
</div>`;
};

const replaceUrl = function(productid, theme) {
  if (!window.history || !window.history.replaceState) {
    return;
  }

  history.replaceState({productid, theme}, null, `?productid=${productid}&theme=${theme}`);
};

const setupCopyEmbed = function(btn) {

  const src = btn.getAttribute('data-src');
  const srcEl = document.querySelector(src);

  if (!srcEl) {
    return;
  }

  btn.addEventListener('click', (event) => {
    const msg = btn.nextElementSibling;


    try {
      if (srcEl.value === '') {
        msg.innerHTML = `<div class="FormField--text is-error">
        <div class="FormField-input">Nothing copied! Please press the "Generate Embed" button before trying to copy.
        </div>
        </div>`;
      } else {
        srcEl.select();
        document.execCommand('copy');
        msg.innerHTML = 'Embed Code was copied to your clipboard!';
      }
    } catch (e) {
      msg.innerHTML = `<div class="FormField--text is-error">
        <div class="FormField-input">
          Unable to copy for you.
          Please select the text in the field above and copy it using your browser's copy feature.
        </div>
      </div>`;
    }

    setTimeout(() => {
      msg.innerHTML = '';
    }, 5000);
  });
};

const updateThemeClass = function(form, theme) {
  const el = form.querySelector('.js-embed-example');

  if (!el) {
    return;
  }

  const classes = ` ${el.className} `
  .replace(/\s(uk-hidden|Embed--\w+)/ig, '')
  .replace(/^\s+|\s$/g, '');

  el.className = `${classes} Embed--${theme}`;
};

const onSubmit = function(event = {}) {
  if (event.preventDefault) {
    event.preventDefault();
  }

  const form = event.target;
  const suggestion = window.suggestion || {};
  const output = form.querySelector('.js-embed-output');

  if (!suggestion.id) {
    output.classList.add('uk-hidden');

    return console.log('no suggestion id');
  }
  const themeInput = form.querySelector('.js-embed-theme:checked');
  const theme = themeInput.value;
  const embedTemplate = document.getElementById('embedTemplate');
  const embedIframe = document.getElementById('embedIframe');

  if (embedTemplate) {
    embedTemplate.value = getEmbedTemplate(suggestion, theme, 'textarea');
  }

  if (embedIframe) {
    embedIframe.innerHTML = getEmbedTemplate(suggestion, theme, 'html');
    window.setTimeout(() => {
      const demoContainer = document.getElementById('demo-container');
      const script = document.createElement('script');
      const {src, ...embedVars} = getEmbedVars(suggestion);
      const dataProps = ['productid', 'theme', 'iframe'];

      script.src = src;

      dataProps.forEach((item) => {
        if (embedVars[item]) {
          script.setAttribute(`data-${item}`, embedVars[item]);
        }
      });

      demoContainer.appendChild(script);
    }, 10);
  }

  output.classList.remove('uk-hidden');

  updateThemeClass(form, theme);
  replaceUrl(suggestion.id, theme);
};

const init = () => {
  const embedGenerators = $('.EmbedGenerator');
  const copyBtns = $('.js-copy');

  embedGenerators.forEach((gen) => {
    gen.addEventListener('submit', onSubmit, false);

    if (window.suggestion) {
      onSubmit({target: gen});
    }
  });

  copyBtns.forEach((btn) => {
    setupCopyEmbed(btn);
  });
};

export {init};
